import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './custom.css'
import App from './App';
import AuthProvider from './Context/AuthContext'

ReactDOM.render(
  <AuthProvider>
    <App />
  </AuthProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
